// extracted by mini-css-extract-plugin
export var growableInput = "_84-0";
export var tagContainer = "_84-2";
export var textInput = "_84-1";